export default "__VITE_ASSET__BjnmMX9d__"